// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class UpsearchModelEnterpriseCoordinatorPatientServiceModelsPatientUpsearchModel {
    static getAttributeTypeMap() {
        return UpsearchModelEnterpriseCoordinatorPatientServiceModelsPatientUpsearchModel.attributeTypeMap;
    }
}
UpsearchModelEnterpriseCoordinatorPatientServiceModelsPatientUpsearchModel.discriminator = undefined;
UpsearchModelEnterpriseCoordinatorPatientServiceModelsPatientUpsearchModel.additionalProperties = false;
UpsearchModelEnterpriseCoordinatorPatientServiceModelsPatientUpsearchModel.attributeTypeMap = [
    {
        "name": "canUpdate",
        "baseName": "canUpdate",
        "type": "boolean"
    },
    {
        "name": "canInsert",
        "baseName": "canInsert",
        "type": "boolean"
    },
    {
        "name": "skipSearch",
        "baseName": "skipSearch",
        "type": "boolean"
    },
    {
        "name": "model",
        "baseName": "model",
        "type": "EnterpriseCoordinatorPatientServiceModelsPatientUpsearchModel"
    },
];
//# sourceMappingURL=upsearchModelEnterpriseCoordinatorPatientServiceModelsPatientUpsearchModel.js.map